export enum BillCombineOption{
  Split = "Split",
  Merge = "Merge"
}
